// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"v3 y5","ribbon":"v4 zc","title":"v5 y7","seasons":"v6 za","genres":"v7 zb","buttonWrapper":"v8 y9","button":"v9 y-"};